import { render, staticRenderFns } from "./HomeAntes.vue?vue&type=template&id=644c9919&scoped=true"
import script from "./HomeAntes.vue?vue&type=script&lang=js"
export * from "./HomeAntes.vue?vue&type=script&lang=js"
import style0 from "./HomeAntes.vue?vue&type=style&index=0&id=644c9919&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644c9919",
  null
  
)

export default component.exports